module.exports = __webpack_public_path__ + "assets/img/7.9b134adc.png";